const Zero = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="-0.5 0.5 64 64"
    xmlSpace="preserve"
    {...props}
  >
    <script />
    <script />
    <circle cx={31.325} cy={32.873} r={30.096} />
    <path
      fill="#FFF"
      d="M31.5 14.08c-10.565 0-13.222 9.969-13.222 18.42 0 8.452 2.656 18.42 13.222 18.42 10.564 0 13.221-9.968 13.221-18.42 0-8.451-2.657-18.42-13.221-18.42zm0 6.946c.429 0 .82.066 1.188.157.761.656 1.133 1.561.403 2.823l-7.036 12.93c-.216-1.636-.247-3.24-.247-4.437 0-3.722.258-11.473 5.692-11.473zm5.266 5.961c.373 1.984.426 4.056.426 5.513 0 3.723-.258 11.475-5.69 11.475-.428 0-.822-.045-1.188-.136a4.343 4.343 0 0 1-.202-.067 3.666 3.666 0 0 1-.336-.11c-1.21-.515-1.972-1.446-.874-3.093l7.864-13.582z"
    />
    <path
      fill="#FFF"
      d="M31.433.5C22.556.5 15.074 3.59 8.979 9.8c-3.087 3.087-5.443 6.607-7.082 10.532A31.646 31.646 0 0 0-.5 32.5c0 4.268.797 8.32 2.397 12.168 1.6 3.85 3.921 7.312 6.969 10.396 3.085 3.049 6.549 5.399 10.398 7.037a31.607 31.607 0 0 0 12.169 2.398c4.229 0 8.34-.826 12.303-2.465 3.962-1.639 7.496-3.994 10.621-7.081 3.011-2.933 5.289-6.297 6.812-10.106C62.73 41 63.5 36.883 63.5 32.5c0-4.343-.77-8.454-2.33-12.303-1.562-3.885-3.848-7.32-6.857-10.33C48.025 3.619 40.385.5 31.433.5zm.134 5.759c7.238 0 13.412 2.566 18.554 7.709 2.477 2.477 4.375 5.31 5.67 8.471 1.296 3.162 1.949 6.518 1.949 10.061 0 7.354-2.516 13.454-7.506 18.33-2.592 2.516-5.502 4.447-8.74 5.781a25.512 25.512 0 0 1-9.927 1.994 26.01 26.01 0 0 1-9.949-1.948c-3.163-1.334-6.001-3.238-8.516-5.716-2.515-2.514-4.455-5.353-5.826-8.516-1.333-3.199-2.017-6.498-2.017-9.927 0-3.467.684-6.787 2.017-9.949 1.371-3.2 3.312-6.074 5.826-8.628 4.99-5.103 11.15-7.662 18.465-7.662z"
    />
  </svg>
);

export default Zero;
